export default __webpack_public_path__ + "static/media/filling_2.d5ab9725.webp";